<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" @input="getCourse"/>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-dept
            :plantCd="searchParam.plantCd"
            type="search"
            label="주관부서"
            name="deptCd"
            v-model="searchParam.deptCd">
          </c-dept>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :comboItems="courseItems"
            type="search"
            itemText="educationCourseName"
            itemValue="eduCourseId"
            name="eduCourseId"
            label="교육과정"
            v-model="searchParam.eduCourseId"
          >
          </c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            type="search"
            codeGroupCd="EDU_STATUS_CD"
            itemText="codeName"
            itemValue="code"
            name="documentStatusCd"
            label="진행상태"
            v-model="searchParam.documentStatusCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            name="educationPeriod"
            label="교육기간"
            v-model="searchParam.educationPeriod"
          ></c-datepicker>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            type="search"
            codeGroupCd="EDU_KIND_FST_CD"
            itemText="codeName"
            itemValue="code"
            name="educationKindCdLarge"
            label="교육종류1"
            v-model="searchParam.educationKindCdLarge"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            type="search"
            codeGroupCd="EDU_KIND_SEC_CD"
            itemText="codeName"
            itemValue="code"
            name="educationKindCdSmall"
            label="교육종류2"
            v-model="searchParam.educationKindCdSmall"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            type="search"
            codeGroupCd="EDU_CLASS_CD"
            itemText="codeName"
            itemValue="code"
            name="educationTypeCd"
            label="교육구분"
            v-model="searchParam.educationTypeCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="교육계획 및 결과 목록"
      :columns="grid.columns"
      :data="grid.data"
      checkDisableColumn="disable"
      :checkClickFlag="false"
      rowKey="eduEducationId"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <div>
          <q-btn-group outline>
            <!-- 교육과정별 대상자 -->
            <!-- <c-btn v-show="isCourse && editable" label="LBL0002837" icon="check" @btnClicked="select" /> -->
            <!-- 등록 -->
            <c-btn label="LBLREG" v-if="editable" icon="add" @btnClicked="linkClick" />
            <!-- 검색 -->
            <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
          </q-btn-group>
        </div>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: "education-result",
  data() {
    return {
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "사업장",
            style: 'width:80px',
            align: "center",
            sortable: true,
          },
          // {
          //   name: "deptNm",
          //   field: "deptNm",
          //   label: "LBLDEPT",
          //   align: "center",
          //   sortable: true,
          // },
          {
            name: "educationName",
            field: "educationName",
            label: "교육명",
            style: 'width:250px',
            align: "left",
            sortable: true,
            type: "link",
          },
          {
            name: "educationCourseName",
            field: "educationCourseName",
            label: "교육과정",
            style: 'width:200px',
            align: "left",
            sortable: true,
          },
          {
            name: "educationDate",
            field: "educationDate",
            label: "교육일",
            style: 'width:180px',
            align: "center",
            sortable: true,
          },
          {
            name: "eduPlanTime",
            field: "eduPlanTime",
            label: "교육시간",
            style: 'width:100px',
            align: "center",
            sortable: true,
          },
          {
            name: "educationKindCdLargeName",
            field: "educationKindCdLargeName",
            label: "교육종류1",
            style: 'width:120px',
            align: "center",
            sortable: true,
          },
          {
            name: "educationKindCdSmallName",
            field: "educationKindCdSmallName",
            label: "교육종류2",
            style: 'width:120px',
            align: "center",
            sortable: true,
          },
          {
            name: "educationTypeName",
            field: "educationTypeName",
            label: "교육구분",
            style: 'width:90px',
            align: "center",
            sortable: true,
          },
          {
            name: "departmentDeptName",
            field: "departmentDeptName",
            label: "주관부서",
            align: "center",
            style: 'width:100px',
            sortable: true,
          },
          {
            name: "documentStatusName",
            field: "documentStatusName",
            label: "진행상태",
            style: 'width:90px',
            align: "center",
            sortable: true,
          },
          {
            name: 'approvalStatusName',
            field: 'approvalStatusName',
            label: '결재진행단계',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
          {
            name: "educationMethodName",
            field: "educationMethodName",
            style: 'width:90px',
            label: "교육방법",
            align: "center",
            sortable: true,
          },
          // {
          //   name: "educationPurpose",
          //   field: "educationPurpose",
          //   // style: 'width:200px',
          //   label: "학습목적",
          //   align: "left",
          //   sortable: true,
          // },
          {
            name: "relatedLawsName",
            field: "relatedLawsName",
            style: 'width:200px',
            label: "관련법규",
            align: "center",
            sortable: true,
          },
          // {
          //   name: "eduQuestionFlag",
          //   field: "eduQuestionFlag",
          //   label: "문제풀이",
          //   style: 'width:80px',
          //   align: "center",
          //   sortable: true,
          // },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        documentStatusCd: null,
        startYmd: '',
        endYmd: '',
        educationPeriod: [],
        eduCourseId: '',
        educationKindCdSmall: null,
        educationKindCdLarge: null,
        educationTypeCd: null,
        deptCd: '',
      },
      editable: true,
      listUrl: "",
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      isResult: false,
      deleteUrl: '',
      courseUrl: '',
      courseItems: [],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  computed: {
    isCourse() {
      return Boolean(this.searchParam.eduCourseId)
    }
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.courseUrl = selectConfig.sop.edu.course.list.url;
      this.listUrl = selectConfig.sop.edu.result.list.url;
      this.deleteUrl = transactionConfig.sop.edu.annual.delete.url;
      // code setting
      this.searchParam.educationPeriod = [this.$comm.getFirstDayThisYear(), this.$comm.getLastDayThisYear()];
      // list setting
      this.getCourse();
      this.getList();
    },
    getCourse() {
      if (this.searchParam.plantCd) {
        this.$http.url = this.courseUrl;
        this.$http.type = 'GET';
        this.$http.param = {plantCd: this.searchParam.plantCd, useFlag: 'Y'};
        this.$http.request((_result) => {
          this.courseItems = _result.data;
          this.searchParam.eduCourseId = null;
        },);
      } else {
        this.courseItems = [];
      }
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */ 
    linkClick(row, col, index) {
      this.popupOptions.title = "LBL0002938"; // 교육계획 및 결과 상세
      this.popupOptions.param = {
        plantCd: row ? row.plantCd : this.searchParam.plantCd,
        eduEducationId: row ? row.eduEducationId : '',
        stepCd: row ? (row.documentStatusCd === 'ESC000001' ?  'ESC0000005' : 'ESC0000010') : 'ESC0000005',
      };
      this.popupOptions.target = () =>
        import(`${"./educationResultDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(type) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    select() {
      if (this.period) {
        this.searchParam.startYmd = this.period[0];
        this.searchParam.endYmd = this.period[1];
      } else {
        this.searchParam.startYmd = '';
        this.searchParam.endYmd = '';
      }
      this.popupOptions.title = "LBL0002841"; // 교육과정별 대상자 연명부
      this.popupOptions.param = {
        plantCd: this.searchParam.plantCd,
        eduCourseId: this.searchParam.eduCourseId,
        startYmd: this.searchParam.startYmd,
        endYmd: this.searchParam.endYmd,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/sop/edu/educationTargetUsersPop.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = false;
      this.popupOptions.width = '95%';
      this.popupOptions.closeCallback = this.closePopup;
    },
  },
};
</script>
